const { hostname, protocol } = window.location;
const com = hostname.split(".").slice(1).join(".");

function urlHack(apiPrefix) {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_API_URL;
  }
  return `${protocol}//${apiPrefix}.${com}`;
}

function nubisApiUrlHack(apiPrefix) {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_NUBIS_API_URL;
  }
  return `${protocol}//${apiPrefix}.${com}`;
}

export const urlDeterminer = (prefix = "platform-api") => {
  return urlHack(prefix);
};

export const urlGoDeterminer = (prefix = "platform-api") => {
  if (process.env.NODE_ENV === "development") {
    return "/apigo";
  }
  return urlHack(prefix);
};

export let url = urlDeterminer();

export let goUrl = urlGoDeterminer();

export let nubisUrl = nubisApiUrlHack("nubis-api");

export const setUrlDeterminer = apiPrefix => {
  url = urlDeterminer(apiPrefix);
};

export const setGoUrlDeterminer = apiPrefix => {
  goUrl = urlGoDeterminer(apiPrefix);
};

export const setNubisUrlDeterminer = apiPrefix => {
  nubisUrl = nubisApiUrlHack(apiPrefix);
};
